<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersList from "@/router/views/admin/users-list";
import TradersList from "@/router/views/admin/traders-list";
import CustomerApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";
import {Priviliges} from "../../../privileges";

export default {
  page: {
    title: "Gestion des abonnements",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,UsersList,TradersList},
  data() {
    return {
      allTradersCount:0,
      allCustomersCount:0,
      privileges:"",
      isAdmin:false,
      hasCustomerUserManagementAccess:false,
      hasTradersUserManagementAccess:false,

    };
  }, 
    mounted(){
      if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
        this.hasCustomerUserManagementAccess=this.privileges.includes(Priviliges[0]["Customer_User_Management"] )
        this.hasTradersUserManagementAccess=this.privileges.includes(Priviliges[0]["Supplier_User_Management"] )
      }
      if(this.isAdmin || this.hasTradersUserManagementAccess ){
        this.getTradersCount()
      }
      if(this.isAdmin || this.hasCustomerUserManagementAccess){
        this.getCustomersCount()
      }

  },
    methods: {
      getTradersCount(){
        UsersApi.getTradersCount().then(
          result => {
            if(result){
              this.allTradersCount=result;
            }else{
              this.allTradersCount=0
            }
            
          }
        )
      },

      getCustomersCount(){
        CustomerApi.getCountCustomers().then(
          result => {
            if(result){
              this.allCustomersCount=result;
            }else{
              this.allCustomersCount=0
            }
            
          }
        )
      },

    }
};
</script>
<template>
  <Layout>
    <div class="row p-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('subscription.cardTitle')}} </h2>
             <p class="card-title-desc font-size-14">
              <u class="mr-1"><span>{{this.allCustomersCount}}</span> {{$t('subscription.customers')}},</u> &nbsp;&nbsp; 
              <u><span>{{this.allTradersCount}}</span> {{$t('subscription.traders')}}</u>.
            </p>
             <b-tabs content-class="p-3 text-muted">
              <b-tab v-if="isAdmin || hasCustomerUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.customers')}}</span>
                  </template>
                  <UsersList/>
                </b-tab>
                <b-tab v-if="isAdmin || hasTradersUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user-tie font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user-tie font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.traders')}}</span>
                  </template>
                  <TradersList/>
                </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

